import React, { useMemo } from "react";

interface HalloweenSpooksProps {
  count?: number;
}

export const HalloweenSpooks: React.FC<HalloweenSpooksProps> = ({ count = 28 }) => {
  const spooks = useMemo(() => {
    const glyphs = ["🎃", "👻", "🦇", "🕷️"];
    return Array.from({ length: count }, (_, i) => {
      const size = 12 + Math.floor(Math.random() * 14);
      return {
        id: i,
        glyph: glyphs[i % glyphs.length],
        style: {
          left: `${Math.random() * 100}%`,
          animationDuration: `${8 + Math.random() * 12}s`,
          animationDelay: `${Math.random() * 10}s`,
          fontSize: `${size}px`,
          opacity: 0.25 + Math.random() * 0.4,
        } as React.CSSProperties,
      };
    });
  }, [count]);

  return (
    <div className="pointer-events-none fixed inset-0 z-40 overflow-hidden" aria-hidden>
      {spooks.map((spook) => (
        <div key={spook.id} className="absolute top-[-20px] animate-snowfall" style={spook.style}>
          {spook.glyph}
        </div>
      ))}
    </div>
  );
};
